<template>
  <ValidationObserver
    ref="obs"
    v-slot="{ valid, handleSubmit }">
    <v-form
      v-model="valid"
      @submit.prevent="handleSubmit(submit)">
      <validation-input
        v-model="item.code"
        :disabled="hasSource"
        :error="codeAlreadyExist"
        rules="required|min:3"
        label="Code" />
      <validation-input
        v-model="item.name"
        rules="required|min:3"
        label="Nom" />
      <validation-input
        v-model="item.price"
        rules="required"
        min="1"
        type="number"
        label="Prix" />
      <div
        v-for="(level, index) of item.price_levels"
        :key="index">
        <v-row>
          <v-col>
            Pallier n°{{ index + 1 }}
          </v-col>
          <v-col class="d-flex justify-end">
            <v-btn
              color="white"
              fab
              @click="sliceLevel(index)">
              <v-icon>mdi-trash-can-outline</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <validation-input
              v-model="level.min"
              rules="required"
              type="number"
              min="0"
              label="Minimum" />
          </v-col>
          <v-col>
            <validation-input
              v-model="level.max"
              col
              rules="required"
              type="number"
              min="1"
              label="Maximum" />
          </v-col>
          <v-col>
            <validation-input
              v-model="level.price"
              col
              rules="required"
              type="number"
              min="1"
              label="Price" />
          </v-col>
        </v-row>
      </div>
      <v-row>
        <v-col class="d-flex justify-center">
          <v-btn
            color="blue "
            type="button"
            text
            @click="addLevel">
            Ajouter un pallier
          </v-btn>
        </v-col>
      </v-row>
      <v-btn
        type="submit"
        color="success"
        class="mr-4">
        Valider
      </v-btn>
    </v-form>
  </ValidationObserver>
</template>

<script>
//   import RESOURCES from '@batimentb/vadimm-js-api/resources'
  const emptyItem = {
    code: null,
    name: null,
    price: null,
    price_levels: []
  }
  export default {
    name: 'BillsItemForm',
    props: {
      source: {
        type: Object
      },
      codes: {
        type: Array
      }
    },
    data () {
      return {
        codeAlreadyExist: false,
        item: {}
      }
    },
    computed: {
      hasSource () {
        if (this.source) {
          return true
        } else return false
      }
    },
    watch: {
      'item.code' (v) {
        if (this.codes && this.codes.includes(v)) {
          this.codeAlreadyExist = true
        } else {
          this.codeAlreadyExist = false
        }
      }
    },
    created () {
      if (this.source) {
        this.item = Object.assign({}, this.source)
      } else {
        this.item = Object.assign({}, emptyItem)
      }
    },
    methods: {
      sliceLevel (idx) {
        this.item.price_levels.splice(idx, 1)
      },
      addLevel () {
        this.item.price_levels.push({
          max: null,
          min: null,
          price: null
        })
      },
      async submit () {
        if (this.codeAlreadyExist) {
          this.$awn.alert('Veuillez saisir un code qui n\'existe pas')
          return
        }
        // let checkLevelsMinMax = true
        // for (let index = 0; index < this.item.price_levels.length; index++) {
        //   if (this.item.price_levels[index].min > this.item.price_levels[index].max) {
        //     checkLevelsMinMax = false
        //   }
        //   if (this.item.price_levels.length > 1 && index < (this.item.price_levels.length - 1) && this.item.price_levels[index].max > this.item.price_levels[index + 1].min) {
        //     checkLevelsMinMax = false
        //   }
        // }
        // if (!checkLevelsMinMax) {
        //   this.$awn.alert('Vérifiez le minimum et maximum des palliers')
        //   return
        // }
        const payload = Object.assign({}, this.item)
        try {
          if (this.source) {
            await this.$billingApi.put(`/items/${this.item.pk}`, payload)
          } else {
            await this.$billingApi.post(`/items`, payload)
          }
          this.$awn.success('Item créé')
          await this.$router.replace({ name: 'billsItems' })
        } catch (err) {
          console.log(err)
        }
      }
    }
  }
</script>

<style scoped>

</style>
